import React from 'react'
import { Flex, Typography } from 'antd'
import { Button, RefreshIcon } from '../Button'

interface RetryOnErrorProps {
  isError: boolean
  label?: React.ReactNode
  retryText?: React.ReactNode
  isRetrying?: boolean
  onRetry: () => void
  children: React.ReactNode
}

export const RetryOnError: React.FC<RetryOnErrorProps> = ({
  isError,
  label,
  retryText = 'Повторить',
  isRetrying = false,
  onRetry,
  children,
}) => {
  if (!isError) {
    return <>{children}</>
  }

  return (
    <Flex
      vertical
      gap={12}
      justify="center"
      align="center"
      style={{ padding: 24 }}
    >
      {label && <Typography.Text type="secondary">{label}</Typography.Text>}
      <Button
        type="secondary"
        customIcon={<RefreshIcon />}
        loading={isRetrying}
        onClick={onRetry}
      >
        {retryText}
      </Button>
    </Flex>
  )
}
